// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sj-c";
export var backButton = "_sj-4";
export var backIcon = "_sj-5";
export var chevronShortcut = "_sj-6";
export var container = "_sj-1";
export var editor = "_sj-8";
export var editorWrapper = "_sj-7";
export var prefix = "_sj-2";
export var searchIcon = "_sj-3";
export var suffix = "_sj-9";
export var suffixContent = "_sj-a";
export var suffixText = "_sj-b";
export var wrapper = "_sj-0";